import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { MainService } from "src/app/app.service";

export interface AccessAuditEntry {
  id: string;
  action: string;
  actor: string;
  targetType: "user" | "area" | "tribe";
  target: string;
  details?: Record<string, unknown>;
  createdAt: string;
}

export interface AccessAuditPage {
  items: Array<AccessAuditEntry>;
  total: number;
}

export interface AccessAuditFilters {
  q?: string;
  target?: string;
  targetType?: string;
  actor?: string;
  action?: Array<string>;
  /** YYYY-MM-DD */
  from?: string;
  /** YYYY-MM-DD (inclui o dia inteiro) */
  to?: string;
  offset?: number;
  limit?: number;
}

@Injectable()
export class AccessAuditService {
  private readonly baseUrl = "/api/v2/access/audit";

  constructor(
    private http: HttpClient,
    private mainService: MainService,
  ) {}

  list(filters: AccessAuditFilters = {}): Observable<AccessAuditPage> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => (params = params.append(key, String(v))));
      } else if (value !== undefined && value !== null && value !== "") {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<AccessAuditPage>(this.baseUrl, { headers: this.mainService.httpOptions.headers, params });
  }
}
